import { getTableColumns } from "drizzle-orm";
import { index, pgTable, text, uuid } from "drizzle-orm/pg-core";
import { createInsertSchema, createSelectSchema } from "drizzle-zod";
import z from "zod";

import {
  documentCategoriesTable,
  documentCategorySchema,
} from "./documentCategoriesSchema";
import { householdMembersTable } from "./householdMembersSchema";
import { patientUploadedFileSchema } from "./patientUploadedFilesSchema";
import { customTimestamp } from "./utils/types";

export const householdMemberDocumentsTable = pgTable(
  "household_member_documents",
  {
    id: uuid("id").primaryKey().defaultRandom(),
    householdMemberId: uuid("household_member_id")
      .references(() => householdMembersTable.id, { onDelete: "cascade" })
      .notNull(),
    documentCategoryId: uuid("document_category_id")
      .references(() => documentCategoriesTable.id)
      .notNull(),
    adminDownloadUrl: text("admin_download_url").unique().notNull(),
    createdAt: customTimestamp("created_at")
      .notNull()
      .$defaultFn(() => new Date().toISOString()),
    updatedAt: customTimestamp("updated_at")
      .notNull()
      .$defaultFn(() => new Date().toISOString())
      .$onUpdateFn(() => new Date().toISOString()),
  },
  table => [
    index("household_member_documents_household_member_id_index").on(
      table.householdMemberId,
    ),
    index("household_member_documents_document_category_id_index").on(
      table.documentCategoryId,
    ),
  ],
);

export const householdMemberDocumentsTableColumns = getTableColumns(
  householdMemberDocumentsTable,
);

export const householdMemberDocumentSchema = createSelectSchema(
  householdMemberDocumentsTable,
);
export type HouseholdMemberDocumentType = z.infer<
  typeof householdMemberDocumentSchema
>;

export const householdMemberDocumentSelectSchema =
  householdMemberDocumentSchema.extend({
    category: documentCategorySchema,
    files: patientUploadedFileSchema.array(),
  });
export type HouseholdMemberDocumentSelectType = z.infer<
  typeof householdMemberDocumentSelectSchema
>;

export const householdMemberDocumentInsertSchema = createInsertSchema(
  householdMemberDocumentsTable,
  {
    householdMemberId: z.uuid(),
    documentCategoryId: z.uuid(),
  },
).omit({
  adminDownloadUrl: true,
  createdAt: true,
  updatedAt: true,
});
export type HouseholdMemberDocumentInsertType = z.infer<
  typeof householdMemberDocumentInsertSchema
>;
